__turbopack_context__.v({
  "button": "DialogFooter-module-scss-module__moQwmW__button",
  "root": "DialogFooter-module-scss-module__moQwmW__root",
});
